import { Record } from 'immutable';
import { IconFavorite, IconWarning } from '@capitalise/ui-design-system';
import { ActionSeverity, ActionSeverityToColor } from '../enums/action-types';

const ActionRecord = Record({
  link: undefined,
  text: undefined,
  priority: undefined,
  severity: undefined,
  count: 0,
});

export default class Action extends ActionRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    return new Action(jsonObject);
  }

  get color() {
    return ActionSeverityToColor[this.severity];
  }

  get icon() {
    return this.severity === ActionSeverity.low ? IconFavorite : IconWarning;
  }
}
